import { useCreationStore } from '../../lib/creationStore'
import { useRefOccupations } from '../../hooks/useRefData'

const DEITIES = [
  '', 'Agrik', 'Halea', 'Ilvir', 'Larani', 'Morgath',
  'Naveh', 'Peoni', 'Sarajin', 'Save-Knor', 'Siem'
]

export function StepOccupation() {
  const store = useCreationStore()
  const { data: occupations } = useRefOccupations()

  const sorted = occupations
    ?.filter(o => o.valid_classes.includes(store.social_class))
    .sort((a, b) => a.occupation_name.localeCompare(b.occupation_name)) ?? []

  return (
    <div>
      <h3>Step 5: Occupation & Deity</h3>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
        <div>
          <label>Occupation</label><br />
          <select value={store.occupation_name}
            onChange={e => store.setField('occupation_name', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }}>
            <option value="">— Select —</option>
            {sorted.map(o =>
              <option key={o.occupation_name} value={o.occupation_name}>
                {o.occupation_name} ({o.occupation_type}, {o.training_years}yr)
              </option>
            )}
          </select>
          {sorted.length === 0 && (
            <p style={{ fontSize: '0.8rem', color: '#999' }}>
              No occupations available for {store.social_class} class.
            </p>
          )}
        </div>
        <div>
          <label>Deity</label><br />
          <select value={store.deity}
            onChange={e => store.setField('deity', e.target.value)}
            style={{ width: '100%', padding: '0.4rem' }}>
            {DEITIES.map(d =>
              <option key={d} value={d}>{d || '— Agnostic —'}</option>
            )}
          </select>
        </div>
        <div>
          <label>Piety (0–5)</label><br />
          <input type="number" min={0} max={5} value={store.piety}
            onChange={e => store.setField('piety', parseInt(e.target.value) || 0)}
            style={{ width: '100%', padding: '0.4rem' }} />
        </div>
      </div>
    </div>
  )
}
